// components/ExperienceSection.js
import React from 'react';
import SectionHeading from '../../Common/SectionHeading';
import Image from 'next/image';

const ExperienceSection = ({title=null, shortDescription=null}) => {
  
  return (
    <section id="experienceSection" style={{ backgroundColor: '#1b5df3' }}>
      <div className="w-11/12 xl:max-w-screen max-w-screen-2xl mx-auto lg:py-8 py-4">
        <div className="grid grid-cols-12 gap-6">
          <div className="lg:col-span-4 col-span-12 my-auto">
            <>
              {(title) &&
                  <SectionHeading title={title} shortDescription={shortDescription} customClass="text-left text-white"/>
              }
            </>
          </div>
          <div className="lg:col-span-8 col-span-12">
            <div className="grid grid-cols-12 gap-6">

              <div className="lg:col-span-6 md:col-span-6 col-span-12">
                <div className="flex items-start">
                  <div className="mr-4">
                    <div className="rounded-circle text-white flex items-center justify-center" style={{ height: '60px', width: '60px', marginTop: '15px' }}>
                      <Image 
                        priority={false} 
                        width={2000} 
                        height={2000} 
                        src={process.env.IMG_CDN+'img/primary-research/Track-white-01.svg'}
                        alt="Track"
                      />
                    </div>
                  </div>
                  <div className="">
                    <h4 className="font-semibold text-white text-xl">Track</h4>
                    <p className="text-base text-white mt-1">Tracking of any indication, brand, player, or metric through different channels</p>
                  </div>
                </div>
              </div>
              <div className="lg:col-span-6 md:col-span-6 col-span-12">
                <div className="flex items-start">
                  <div className="mr-4">
                    <div className="rounded-circle text-white flex items-center justify-center" style={{ height: '60px', width: '60px', marginTop: '15px' }}>
                      <Image 
                        priority={false} 
                        width={2000} 
                        height={2000} 
                        src={process.env.IMG_CDN+'img/primary-research/Analyze-white-01.svg'}
                        alt="Analyze" 
                      />
                    </div>
                  </div>
                  <div className="">
                    <h4 className="font-semibold text-white text-xl">Analyze</h4>
                    <p className="text-base text-white mt-1">Understanding the market granularity by real-time assessment from different stakeholder perspectives</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-6">
              <div className="lg:col-span-6 md:col-span-6 col-span-12">
                <div className="flex items-start">
                  <div className="mr-4">
                    <div className="rounded-circle text-white flex items-center justify-center" style={{ height: '60px', width: '60px', marginTop: '15px' }}>
                      <Image 
                        priority={false} 
                        width={2000} 
                        height={2000} 
                        src={process.env.IMG_CDN+'img/primary-research/Design-white-01.svg'}
                        alt="Design"
                      />
                    </div>
                  </div>
                  <div className="">
                    <h4 className="font-semibold text-white text-xl">Design</h4>
                    <p className="text-base text-white mt-1">Achieve success through effective planning and execution and leading to effective positioning and targeting</p>
                  </div>
                </div>
              </div>
              <div className="lg:col-span-6 md:col-span-6 col-span-12">
                <div className="flex items-start">
                  <div className="mr-4">
                    <div className="rounded-circle text-white flex items-center justify-center" style={{ height: '60px', width: '60px', marginTop: '15px' }}>
                      <Image 
                        priority={false} 
                        width={2000} 
                        height={2000} 
                        src={process.env.IMG_CDN+'img/primary-research/Execute-white-01.svg'}
                        alt="Execute" 
                      />
                    </div>
                  </div>
                  <div className="">
                    <h4 className="font-semibold text-white text-xl">Execute</h4>
                    <p className="text-base text-white mt-1">Manage expectations and uncertainties of the evolving healthcare market to remain relevant</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;